import Phaser from "phaser";
import { BootScene } from "./scenes/BootScene";
import { GameScene } from "./scenes/GameScene";

export function createGame(parent: HTMLElement): Phaser.Game {
  const config: Phaser.Types.Core.GameConfig & { resolution: number } = {
    type: Phaser.CANVAS,
    parent,
    backgroundColor: "#f5f6fc",
    transparent: false,
    antialias: true,
    pixelArt: false,
    resolution: Math.min(window.devicePixelRatio, 2),
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: "100%",
      height: "100%",
    },
    render: { powerPreference: "high-performance" },
    scene: [BootScene, GameScene],
  };
  return new Phaser.Game(config);
}
